import type { BoardDto } from '@mm/shared';
import { apiFetch } from './client';

export async function listBoards(studentId: string): Promise<{ items: BoardDto[] }> {
  const res = await apiFetch(`/students/${studentId}/boards`);
  if (!res.ok) throw new Error(`listBoards ${res.status}`);
  return res.json();
}

export async function createBoard(studentId: string, title?: string): Promise<BoardDto> {
  const res = await apiFetch(`/students/${studentId}/boards`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(title ? { title } : {}),
  });
  if (!res.ok) throw new Error(`createBoard ${res.status}`);
  return res.json();
}

export async function getBoard(id: string): Promise<BoardDto> {
  const res = await apiFetch(`/boards/${id}`);
  if (!res.ok) throw new Error(`getBoard ${res.status}`);
  return res.json();
}

export async function renameBoard(id: string, title: string): Promise<BoardDto> {
  const res = await apiFetch(`/boards/${id}`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`renameBoard ${res.status}`);
  return res.json();
}

export async function duplicateBoard(id: string): Promise<BoardDto> {
  const res = await apiFetch(`/boards/${id}/duplicate`, { method: 'POST' });
  if (!res.ok) throw new Error(`duplicateBoard ${res.status}`);
  return res.json();
}

export async function deleteBoard(id: string): Promise<void> {
  const res = await apiFetch(`/boards/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`deleteBoard ${res.status}`);
}

export async function loadBoardSnapshot(id: string): Promise<{ document: unknown | null }> {
  const res = await apiFetch(`/boards/${id}/snapshot`);
  if (!res.ok) throw new Error(`loadBoardSnapshot ${res.status}`);
  return res.json();
}

export async function saveBoardSnapshot(id: string, document: unknown): Promise<void> {
  const res = await apiFetch(`/boards/${id}/snapshot`, {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ document }),
  });
  if (!res.ok) throw new Error(`saveBoardSnapshot ${res.status}`);
}

export async function uploadBoardAsset(
  boardId: string,
  file: File,
): Promise<{ url: string; size: number; mime: string }> {
  const fd = new FormData();
  fd.append('file', file);
  const res = await apiFetch(`/boards/${boardId}/assets`, {
    method: 'POST',
    body: fd,
  });
  if (!res.ok) throw new Error(`uploadBoardAsset ${res.status}`);
  return res.json();
}
